
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBeaconTowerSouth as ObiBeaconTowerSouthElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-beacon-tower-south.js';
 
 
 

 
 export const ObiBeaconTowerSouth = createComponent({
   react: React,
   tagName: 'obi-beacon-tower-south',
   elementClass: ObiBeaconTowerSouthElement,
   events: {
     
   }
  });
 
 